import { morph } from '@theme/morph';
import { Component } from '@theme/component';
import { StandardEvents, ProductSelectEvent } from '@shopify/events';

/**
 * Product page badges. Some badges depend on the selected variant (for example low
 * stock), so the badges are refreshed from the section HTML fetched on variant change.
 * The matching element in the new HTML is found by `data-badges-id`.
 *
 * @extends {Component}
 */
class ProductPageBadges extends Component {
  /** @type {Element | null} */
  #section = null;

  connectedCallback() {
    super.connectedCallback();
    this.#section = this.closest('.shopify-section, dialog');
    this.#section?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#section?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
    this.#section = null;
  }

  /**
   * @param {ProductSelectEvent} event - The product select event.
   */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        const newBadges = detail.html.querySelector(`product-page-badges[data-badges-id="${this.dataset.badgesId}"]`);
        if (!newBadges) return;

        morph(this, newBadges, { childrenOnly: true });
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[product-page-badges] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('product-page-badges')) {
  customElements.define('product-page-badges', ProductPageBadges);
}
